"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useReferencedState(initialState) {
    const [initialRefValue, setStateValue] = (0, react_1.useState)(initialState);
    const valueRef = (0, react_1.useRef)(initialRefValue);
    const setValue = (0, react_1.useCallback)(nextValue => {
        // First set up reference value to access it immediately
        // Might be useful to prevent updates from outside a component
        valueRef.current =
            typeof nextValue === 'function' ? nextValue(valueRef.current) : nextValue;
        // And then setting React state to make lifecycle update
        setStateValue(nextValue);
    }, []);
    return [valueRef, setValue];
}
exports.default = useReferencedState;
//# sourceMappingURL=useReferencedState.js.map